<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col lg="7">
          <b-card-group class="row">
            <b-card no-body class=" py-4  d-md-down-none card-login col-lg-5">
              <b-card-body class="text-center">
                <div class="ml-2">
                  <img  class="navbar-brand-full d-none d-md-block justify-content-center"  src="img/ms_logo.png"
                        alt="MS">
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body class="p-4 col-md-10  col-lg-7">
              <b-card-body :style="clientList.length > 0 ? 'display: flex; justify-content: center; align-items:center' : ''">
                <b-form @submit.prevent="submitLogin" class="mr-2" v-if="clientList.length === 0">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-envelope"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      :state="usernameState"
                      type="text"
                      placeholder="Email"
                      class="form-control"
                      autocomplete="username"
                      aria-describedby="inputUsernameFeedback"
                      v-model.trim="username">
                    </b-form-input>
                    <b-form-invalid-feedback id="inputUsernameFeedback">
                      Field is mandatory
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      placeholder="Lozinka"
                      :state="passwordState"
                      class="form-control"
                      autocomplete="current-password"
                      aria-describedby="inputPasswordFeedback"
                      v-model="password">
                    </b-form-input>
                    <b-form-invalid-feedback id="inputPasswordFeedback">
                      Field is mandatory
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="danger" class="px-4">ULAZ
                      </b-button>
                    </b-col>
                    <b-col cols="12" class="mt-4">
                      <a   :href="'https://eracun.management-solutions.biz/reset-password'">Zaboravljena lozinka</a>
                    </b-col>
                  </b-row>
                </b-form>
                <b-form class="mr-2" v-else>
                  <b-input-group class="mb-4" style="width: 15rem;">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-home"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-select
                      v-model="client_id">
                      <b-form-select-option value="null">Odaberi klijenta</b-form-select-option>
                      <b-form-select-option :key="client.id" v-for="client in clientList" :value="client.id">
                        {{client.name}}
                      </b-form-select-option>
                    </b-form-select>
                  </b-input-group>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"/>
  </div>
</template>

<script>

  import routeName from '@/router/routeNames'
  import loading from 'vue-full-loading'
  import {required, minLength} from 'vuelidate/lib/validators'
  import {toast} from '@/shared/plugins/toastr'
  import * as r_permission from '@/shared/route_permission'
  import {CLIENT_ID, CLIENT_ROLE, INSTITUTION_USER, INSTITUTION_VIEW_USER} from "@/shared/constants";


  export default {
    name: 'Login',
    components: {
      loading
    },
    data() {
      return {
        username: '',
        password: '',
        usernameState: null,
        passwordState: null,
        show: false,
        label: 'Logging in...',
        overlay: true,
        error: "",
        routeName,
        client_id: null,
        clientList: [],
      }
    },
    computed: {
      errorMessage: function () {
        return this.error
      }

    },
    validations: {
      username: {
        required,
        minLength: minLength(2)
      },
      password: {
        required,
        minLength: minLength(2)
      }
    },
    methods: {
      submitLogin() {
        localStorage.clear();
        if (this.$v.username.$invalid) {
          this.usernameState = false
        }

        if (this.$v.password.$invalid) {
          this.passwordState = false
        }

        if (this.$v.$invalid) {
          return
        }

        const formData = {
          password: this.password,
          username: this.username
        }

        this.show = true

        this.$store.dispatch('auth/actionLogin', {username: formData.username, password: formData.password})
          .then(() => {
            this.$store.dispatch('user/actionSetUser').then(userResponse =>{
              if(userResponse.role.id === CLIENT_ROLE) {
                  this.clientList = userResponse.clients ? userResponse.clients : [];

                  if(this.clientList.length > 1) {
                    this.$store.dispatch('client/actionSetAvailableClientList', this.clientList)
                  } else if (this.clientList.length === 1 ) {
                    this.client_id =this.clientList[0].id
                    this.$store.dispatch('client/actionSetClient',  this.client_id);
                    localStorage.setItem(CLIENT_ID, this.client_id)
                    this.$router.replace({name: routeName.RN_HOME})
                    this.$router.replace({name: routeName.RN_HOME})
                  } else if (this.clientList.length === 0) {
                    this.$router.replace({name: routeName.RN_HOME})
                  }
              } else {
                this.$router.replace({name: routeName.RN_HOME})
              }
              this.$store.dispatch('user/actionSetUserPermissions').then(()=>{

                  toast({
                    'title': 'Login successful',
                    'type': 'success'
                  })


              }).finally(()=>{
                this.show = false
              })
            })

          })
          .catch(() => {
            this.show = false
          toast({
            'title': 'Login failed',
            'message': 'Provide the correct username and password',
            'type': 'error'
          })
        })
      }
    },
    watch: {
      client_id: {
        async handler(value) {
          if(value) {
            await this.$store.dispatch('client/actionSetClient', value);
            localStorage.setItem(CLIENT_ID, value)
            this.$router.replace({name: routeName.RN_HOME})
          }
        }
      }
    }
  }
</script>
